function animateIn(selector, options = {}) {
    const settings = Object.assign(
        {
            offset: 0,
            modifier: '__in'
        },
        options
    );

    document.querySelectorAll(selector).forEach((item) => {
        let observer;

        function animateBlock() {
            item.classList.add(settings.modifier);

            if (observer) {
                observer.unobserve(item);
            }
        }

        if (!('IntersectionObserver' in window)) {
            animateBlock();
            return;
        }

        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        animateBlock();
                    }
                });
            },
            {
                root: null,
                threshold: 0,
                rootMargin: `0px 0px -${settings.offset}px 0px`
            }
        );

        observer.observe(item);
    });
}

window.addEventListener('load', () => {
    animateIn('.__animate', {
        offset: 100,
        modifier: '__animatein'
    });

    animateIn('.__animateleft', {
        offset: 0,
        modifier: '__animatein'
    });

    animateIn('.__animateright', {
        offset: 0,
        modifier: '__animatein'
    });

    animateIn('.__animateup', {
        offset: 0,
        modifier: '__animatein'
    });

    animateIn('.__animatenow', {
        offset: 0,
        modifier: '__animatein'
    });
});
